import {BaseSS} from './BaseSS';

const STORAGE_KEY = 'expandedAudioConf';

export class ExpandedAudioConf extends BaseSS<string> {
  constructor() {
    super(STORAGE_KEY);
  }
}
